module.exports = __webpack_public_path__ + "img/hero-8.5fe210fb.png";